<div class="p-grid">
  <div class="p-col-6">
    <a class="logo-container" href="https://www.iotsens.com" target="_blank">
      <img alt="iotsens" src="../../../logo-collapsed.png">
    </a>
  </div>
  <div class="p-col-6 footer-icons">
    <a href="https://www.facebook.com/iotsens/" target="_blank"><i class="pi pi-facebook"></i></a>
  </div>
</div>
